import { useState, useEffect } from 'react';
import { useUser } from '../Auth/AuthContext';
import { useParams } from 'react-router-dom';
import { TableauViz, TableauEventType } from '@tableau/embedding-api';
import { PutObject } from '../Auth/S3';
import Grid from '@mui/material/Grid';
import ActionButtons from '../Buttons/ActionButtons';
import JobRecordRowAttribute from './JobRecordRowAttribute';
import attributes from '../Config/attributes';

const JobRecordTableau = props => {
    const [item, setItem] = useState({})
    const [src, setSrc] = useState();
    const [parameters, setParameters] = useState();

    const user = useUser();
    const params = useParams();

    const viz = new TableauViz();
    viz.hideTabs = true;
    viz.toolbar = 'hidden';

    useEffect(() => {
        setItem(props.item)
    }, [props])

    useEffect(() => {
        const vizDiv = document.getElementById("tableauViz");
        vizDiv.innerHTML = '';
        if (src) {
            viz.src = src
            viz.addEventListener(TableauEventType.FirstInteractive, handleLoaded)
            vizDiv.appendChild(viz)
        }
    }, [src])

    const handleChange = e => {
        setItem({
            ...item,
            ...{ [e.target.name]: e.target.value },
            ...(e.target.name === 'tableauParameter' ? {
                tableauParameterValues: parameters.find(x => x.name === e.target.value)?.values
            } : {})
        })
    }

    const handleLoaded = async () => {
        let parametersAsync = await viz.workbook.getParametersAsync();
        parametersAsync = parametersAsync.filter(
            x => (x?.allowableValues?.allowableValues || []).length > 0
        )
        setItem({ tableauUrl: item.tableauUrl })
        setParameters(parametersAsync.map(x => ({
            name: x.name,
            values: x.allowableValues.allowableValues?.map(y => y.value)
        })))
    }

    const saveData = () => {
        PutObject(
            user,
            `_payloads/tableauserver/${params.id}_${props.rowNumber}.json`,
            JSON.stringify({tableauParameterValues: item?.tableauParameterValues})
        )
        // props.handler({ target: { name: 'tableau', value: item } })}
    }

    return (
        <Grid container>
            <Grid item xs={12} sx={{ py: '1.25rem' }}>
                <Grid container>
                    <Grid item xs>
                        <JobRecordRowAttribute
                            item={item}
                            attr={attributes.tableauUrl}
                            handler={handleChange}
                        />
                    </Grid>
                    <ActionButtons
                        labels={{ refresh: "Load", save: "Confirm" }}
                        refresh={() => setSrc(item.tableauUrl)}
                        // save={() => props.handler({ target: { name: 'tableau', value: item } })}
                        save={saveData}
                    />
                </Grid>

            </Grid>

            <Grid item xs={6}>
                <JobRecordRowAttribute
                    item={item}
                    attr={attributes.tableauParameter}
                    disabled={(parameters === undefined)}
                    options={parameters ? parameters.map(x => ({ value: x.name, label: x.name })) : [{ value: item?.tableauParameter, label: item?.tableauParameter }]}
                    handler={handleChange}
                />
            </Grid>
            <Grid item xs={6}>
                <JobRecordRowAttribute
                    item={item}
                    attr={attributes.tableauParameterValues}
                />
            </Grid>

            <div id="tableauViz" />

        </Grid>
    )
}
export default JobRecordTableau